import UAParser from 'ua-parser-js';

export const useUserAgentParser = () => {
  if (window?.navigator?.userAgent === undefined) return undefined;

  return new UAParser(window.navigator.userAgent);
};
